export default __webpack_public_path__ + "static/business-logo-1c959ed471e44bdb311f28c04c99c571.svg";